import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { defineMessages, useIntl } from "react-intl"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import { Box } from "@material-ui/core"
import auth from "../../api/authSlice"
import LoginForm from "./LoginForm"
import ForgotPasswordContainer from "../user/ForgotPasswordContainer"
import LoginText from "./LoginText"
import useLoginStyles from "./loginStyle"
import DialogTitleWithClose from "../../component/dialog/DialogTitleWithClose"

const messages = defineMessages({
  dialog: {
    id: "modal.resetpassword.title",
    defaultMessage: "Reset password"
  }
})

const LoginPage = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useLoginStyles()
  const [showPasswordModal, openPasswordModal] = useState(false)
  const { formatMessage: format } = useIntl()

  const handleLogin = (values) => {
    values.email.toLowerCase()
    const { actions } = auth
    return dispatch(actions.login(values))
  }

  const handleClosePasswordModal = () => {
    openPasswordModal(false)
  }

  return (
    <Box className={classes.loginWrapper}>
      <LoginText />

      <Box display="flex" alignItems="center">
        <LoginForm
          handleSave={handleLogin}
          register
          handleForgotPassword={() => openPasswordModal(true)}
          history={history}
        />
      </Box>
      <Dialog
        data-testid="handlePasswordDialog"
        open={showPasswordModal}
        onClose={() => openPasswordModal(false)}
      >
        <DialogTitleWithClose onClose={handleClosePasswordModal}>
          {format(messages.dialog)}
        </DialogTitleWithClose>
        <DialogContent>
          <ForgotPasswordContainer onClose={handleClosePasswordModal} />
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default LoginPage
